module.exports = __webpack_public_path__ + "static/media/linkedin.f265b316.svg";